import {FLAG_WORKING, MASK_SERVICE_TYPE, TYPE_SERVICES, VALUE_TYPE_STRIPE, MASK_AGENT } from "../constants/bitwiseOperations";
import { ACCOUNT_TYPES } from '../constants/general'

export default {
    branches: {
        properties: {
            isList: (type) => (parseInt(type, 10) & 256) !== 0,
            isNumeric: (type) => (parseInt(type, 10) & 512) !== 0,
            isText: (type) => (parseInt(type, 10) & 1024) !== 0,
            isOneOf: (types = [], type) => types.some($0 => (parseInt(type, 10) & $0) !== 0),
            getType(type) {
                if (this.isList(type)) return 'list'
                if (this.isText(type)) return 'text'
                if (this.isNumeric(type)) return 'numeric'

                return 'undefined'
            }
        }
    },
    orders: {
        status: {
            isService: (status) => (status & MASK_SERVICE_TYPE) === TYPE_SERVICES,
            inServiceInProgress: (status) => (this.isService(status)&FLAG_WORKING) === FLAG_WORKING
        },
    },
    payments: {
        have: {
            stripe: (payments = []) => payments.some($0 => (parseInt($0.options || 0, 10) & MASK_AGENT) === VALUE_TYPE_STRIPE)
        }
    },
    account: {
        isOneOf: (types = [], type) => types.some($0 => $0 === type),
        is: (accountType, type) => accountType === type,
        isProvider: (type) => type === ACCOUNT_TYPES.provider,
        isClient: (type) => type === ACCOUNT_TYPES.client,
    }
}



// WEBPACK FOOTER //
// ./src/utils/bitwise.js